import SceDropDown from './dropDown';
class SetUpEmailDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      droplist: this.props.dropDownData.emailSet,
      placeholder: !_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : 'Enter Email',
    };
  }
  getEmailList(emailList) {
    let that = this;
    let emailValueArr = emailList.map((obj) => obj.email);
    emailList = emailList.filter((item, i) => {
      return emailValueArr.indexOf(item.email) === i;
    });
    let selectBoxEmailList = emailList.map(function (emailId, index) {
      return {
        name: emailId.email, value: emailId.email,
      };
    });

    this.setState({ ...this.state, droplist: selectBoxEmailList }, () => { });
  }
  componentWillMount() {
    this.getEmailList(this.props.dropDownData.emailSet);
  }
  componentWillReceiveProps(nextProps) {
    this.getEmailList(nextProps.dropDownData.emailSet);
  }
  onAddEmailConfirmDialogClick = (e, name, value, encNum) => {
    this.props.onModifyCustomerPreference('email', value, null);
  }
  onSelectDropDown = (e) => {
    var reqObj = { ...e };
    reqObj.id = this.props.id;
    this.props.onSelectDropDown(reqObj);
  }
  render() {
    return (
      <div>
        <SceDropDown
          id={'malAddrSelection_' + this.props.dropdownDifferentiator}
          contactType={"email"}
          selectBoxData={this.state.droplist}
          handleClick={this.onSelectDropDown}
          placeholder={this.state.placeholder}
          errorMessage={this.props.isSameValueError ? 'Primary and Secondary Contact details cannot be same.' : ''}
          selectErrorMessage={'Please select email address'}
          isError={this.props.isSameValueError}
          triggerOnClick={this.props.triggerOnClick}
          onAddEmailConfirmDialogClick={this.onAddEmailConfirmDialogClick}
          inputButtonText={this.props.inputButtonText}
          addContactValueArr={this.props.addContactValueArr}
        />
      </div>
    );
  }
}

export default SetUpEmailDropdown;
